import { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Gauge } from 'lucide-react';
import { calibK } from '../lib/aquaCalib';
import { isHW } from '../lib/aquaNet';

const nf = (v, d = 2) => (v == null || !Number.isFinite(+v) ? '–' : (+v).toFixed(d).replace('.', ','));
const rerun = () => setTimeout(() => window.dispatchEvent(new Event('giss-aqua-rerun')), 60);

// roughness from the measured static / flowing pressure at this hydrant, applied to the whole flow path after preview
export function CalibK({ t, obj, project, q, mS, mF }) {
  const [busy, setBusy] = useState(false), [r, setR] = useState(null);
  const dp = mS !== '' && mS != null && mF !== '' && mF != null ? +mS - +mF : null;
  if (isHW(project)) return <small className="muted" data-testid="aq-calib-hw">{t.aqCalibHw}</small>;
  const run = async () => {
    setBusy(true); setR(null);
    try { setR(await calibK(project, project.aqua || {}, obj.id, q, dp)); } catch (e) { toast.error(String(e?.message || e)); }
    setBusy(false);
  };
  const apply = () => {
    window.dispatchEvent(new CustomEvent('giss-pipes-patch', { detail: { ids: r.pipes, patch: (p) => ({ hyd: { ...(p.hyd || {}), k: r.k, kSrc: 'calib' } }) } }));
    toast.success(t.aqCalibOk.replace('{k}', nf(r.k)).replace('{n}', r.pipes.length));
    setR(null); rerun();
  };
  const names = r?.pipes ? r.pipes.map((id) => project.pipes.find((p) => p.id === id)?.name || '?') : [];
  return (
    <div className="aq-calib" data-testid="aq-calib">
      <b><Gauge size={14} /> {t.aqCalibTitle}</b>
      <small className="muted">{t.aqCalibHint}</small>
      <button type="button" className="btn btn-dark btn-sm" data-testid="aq-calib-run" disabled={busy || dp == null || dp <= 0 || !(q > 0)} onClick={run}>{busy ? <Loader2 size={14} className="spin" /> : <Gauge size={14} />} {t.aqCalibRun}{dp > 0 ? ` (Δp ${nf(dp)} bar, ${nf(q, q < 0.1 ? 3 : 1)} l/s)` : ''}</button>
      {(dp == null || dp <= 0) && <small className="muted" data-testid="aq-calib-need">{t.aqCalibNeed}</small>}
      {r?.error && <small className="aq-warn" data-testid="aq-calib-err">{t[`aqCalibErr_${r.error}`] || t.aqHydCalcErr}</small>}
      {r && !r.error && <div className="aq-calib-res" data-testid="aq-calib-res">
        {r.low && <small className="aq-warn">{t.aqCalibLow.replace('{d}', nf(r.dpMin))}</small>}
        {r.high && <small className="aq-warn">{t.aqCalibHigh.replace('{d}', nf(r.dpMax))}</small>}
        <b data-testid="aq-calib-k">k = {nf(r.k, r.k < 0.1 ? 3 : 2)} mm</b>
        <small>{t.aqCalibPath.replace('{n}', r.pipes.length)}: {names.join(', ')}</small>
        <button type="button" className="btn btn-green btn-sm" data-testid="aq-calib-apply" disabled={r.low || r.high} onClick={apply}>{t.aqCalibApply}</button>
      </div>}
    </div>
  );
}
